module.exports = __webpack_public_path__ + "static/media/signupleft.b1a5d0a5.webp";